export default class Tag {
	constructor(
		nome='',
		icone='',
		cor=''
	){
		this.nome = nome;
		this.icone = icone;
		this.cor = cor;
	}
}